import { Link } from 'react-router-dom'

import { dashboardRoutes } from '../../constants/routes'
import type { RecentBooking } from '../../types'
import { RecentBookingItem } from './RecentBookingItem'

type RecentBookingsCardProps = {
  bookings: RecentBooking[]
}

export const RecentBookingsCard = ({ bookings }: RecentBookingsCardProps) => (
  <section className="flex w-full flex-col gap-[15px] rounded-[12px] bg-white px-[13px] py-[17px] xl:h-[698px]">
    <div className="flex items-center justify-between whitespace-nowrap font-host text-[16px] font-medium leading-normal">
      <h2 className="text-black">Recent Bookings</h2>
      <Link
        to={dashboardRoutes.bookings}
        className="text-dash-link underline decoration-solid underline-offset-2"
      >
        View All
      </Link>
    </div>

    <div className="flex flex-col gap-[8px]">
      {bookings.length > 0 ? (
        bookings.map((booking) => (
          <RecentBookingItem key={booking.id} booking={booking} />
        ))
      ) : (
        <p className="font-host text-[14px] text-dash-muted">No recent bookings.</p>
      )}
    </div>
  </section>
)
